// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3uYRc","inputDescription":"styles_inputDescription__3unmO"};